/**
 * 时间格式化（默认格式：yyyy-MM-dd HH:mm:ss）
 * @param {*} timestamp 时间戳
 * @param {*} format 格式化字符串
 * @returns 格式化后的时间字符串
 */
export const formatTimestamp = (timestamp, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!timestamp) return ''
  const ts = Number(timestamp)
  // 若为 10位数字（秒级），转换为毫秒级（*1000）
  const msTimestamp = ts.toString().length === 10 ? ts * 1000 : ts
  const date = new Date(msTimestamp)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  // 时间格式化映射对象
  const formatMap = {
    YYYY: year,
    MM: month,
    DD: day,
    HH: hours,
    mm: minutes,
    ss: seconds
  }

  // 替换格式字符串中的占位符
  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => formatMap[match])
}

/**
 * 检查是否处在销帮帮环境内
 */
export const checkXbbEnvironment = () => {
  // 获取完整 URL 中的搜索参数部分（即 "?inxbb=1"）
  const searchParams = new URLSearchParams(window.location.search)
  // 通过参数名 "inxbb" 获取对应的值
  const inXbbValue = searchParams.get('inxbb') || ''
  return +inXbbValue === 1
}
